import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ComingSoon from "@/pages/ComingSoon";
import Dashboard from "@/pages/Dashboard";
import Listings from "@/pages/Listings";
import ListingForm from "@/pages/ListingForm";
import Verification from "@/pages/Verification";
import CategoryRequests from "@/pages/CategoryRequests";
import Categories from "@/pages/Categories";
import Cities from "@/pages/Cities";
import Employees from "@/pages/Employees";
import Subscribers from "@/pages/Subscribers";
import ActivityLog from "@/pages/ActivityLog";
import CsvImport from "@/pages/CsvImport";

function Protected({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F7FA]" data-testid="auth-loading">
        <div className="text-[#475569] text-sm">Loading...</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" state={{ from: location }} replace />;
  return children;
}

function LoginGate() {
  const { user } = useAuth();
  if (user) return <Navigate to="/admin" replace />;
  return <Login />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<ComingSoon />} />
            <Route path="/login" element={<LoginGate />} />
            <Route path="/admin" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="listings" element={<Listings />} />
              <Route path="listings/new" element={<ListingForm />} />
              <Route path="listings/:id" element={<ListingForm />} />
              <Route path="verification" element={<Verification />} />
              <Route path="category-requests" element={<CategoryRequests />} />
              <Route path="categories" element={<Categories />} />
              <Route path="cities" element={<Cities />} />
              <Route path="employees" element={<Employees />} />
              <Route path="subscribers" element={<Subscribers />} />
              <Route path="activity" element={<ActivityLog />} />
              <Route path="import" element={<CsvImport />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
